export default __webpack_public_path__ + "static/media/userSuccess.54a60918.svg";